/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Deleting_Transcript_FileInputs */



/**
* | output |
* | --- |
* | "Error deleting transcript file. {error}" |
*
* @param {Error_Deleting_Transcript_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_deleting_transcript_file = /** @type {((inputs: Error_Deleting_Transcript_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Deleting_Transcript_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la suppression du fichier de transcription. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Löschen der Protokolldatei. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'eliminazione del file di trascrizione. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при удалении файла стенограммы. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al eliminar el archivo de transcripción. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除成绩单文件时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トランスクリプトファイルの削除中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट फ़ाइल को हटाने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao excluir o arquivo de transcrição. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error deleting transcript file. ${i?.error}`)
});